import Icon from '@components/icon';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import type { ChangeEventHandler, FC } from 'react';

import { Checkbox } from 'components/Checkbox';
import { Stack } from 'components/Stack';
import { notificationsFaq } from 'constants/pages';
import { useStore } from 'hooks/useStore';

import { Trial } from '../SubsSettings/Trial';

import css from './SubsToggle.module.css';

const SubsToggle: FC<TSubsToggleProps> = ({ isChecked, onCheck }) => {
  const {
    app: { i18n },
    savedFilters: { popup },
  } = useStore();

  if (popup?.isEdit && popup.validationResult?.resultFilter?.subscription) return null;

  return (
    <div className={css.sub}>
      <div className={css.subTitle}>
        <strong>{i18n.filterPopup.signUp}</strong>
      </div>

      <Stack className={css.checkboxContainer} gap={6}>
        <Checkbox checked={isChecked} contentClassName={css.checkboxContent} onChange={onCheck}>
          {i18n.filterPopup.subscribe}
          {popup?.hasOnlyPersonalBoards && <span className={css.free}>{i18n.common.free}</span>}
        </Checkbox>

        <Trial mode="short" />

        {!isChecked && (
          <>
            <div className={cn(css.info, css.cbInfoItem)}>{i18n.filterPopup.saveTime}</div>
            <a className={cn(css.cbInfoItem, 'glz-link glz-is-medium glz-is-underline')} href={notificationsFaq}>
              {i18n.filterPopup.moreAbout}
              <Icon className="glz-after-icon" color="currentColor" height={14} name="ic_external" width={9} />
            </a>
          </>
        )}
      </Stack>
    </div>
  );
};

export type TSubsToggleProps = {
  isChecked: boolean;
  onCheck: ChangeEventHandler;
};

const connected = observer(SubsToggle);

export { connected as SubsToggle };
